export default __webpack_public_path__ + "ce491bf.png";